// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__8taLe","selected":"Chip_selected__xSIrg"};